import {
  Select as AntdSelect,
  SelectProps as AntdSelectProps,
  AutoComplete as AntdAutocomplete,
  AutoCompleteProps as AntdAutocompleteProps,
} from "antd";
import { CMP_PREFIX } from "@/base/constant";
import { ArrowDownIcon } from "@/base/static/index";

export interface SelectProps extends AntdSelectProps {}
export interface AutocompleteProps extends AntdAutocompleteProps {}

export const selectPrefixCls = `${CMP_PREFIX}-select`;

export const Select = ({ size = "large", ...props }: SelectProps) => {
  return (
    <AntdSelect
      size={size}
      suffixIcon={<ArrowDownIcon />}
      notFoundContent={"No data"}
      {...props}
    />
  );
};

export const Autocomplete = ({
  size = "large",
  ...props
}: AutocompleteProps) => {
  return (
    <AntdAutocomplete size={size} notFoundContent={"No data"} {...props} />
  );
};
